import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { KeyboardArrowLeft } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { colors } from '../../theme/style';
import { connect } from 'react-redux';

import { goBack, setSelectedClinic } from '../../redux/actions';
import { getCurrPath, isAdminClinic, isLoggedInis, isUserClinic } from '../../utils/CFuncs';
import { roles, urls } from '../../utils/Objects';

class BackToPage extends Component {
  onClick = () => {
    this.props.goBack();
  };

  getPageName = () => {
    let screenName = [...this.props.nav.historyBack]?.slice(-1)[0].screenName;
    screenName = screenName.split('/')[1];
    if (getCurrPath().includes(screenName) || screenName === '') {
      return <></>;
    } else
      return (
        <div onClick={this.onClick} style={style.nav}>
          <KeyboardArrowLeft /> <span>{screenName}</span>
        </div>
      );
  };
  render() {
    console.log({ historyBack: this.props.historyBack });

    return <div style={style.container}>{[...this.props.nav.historyBack]?.pop() && <div>{this.getPageName()}</div>}</div>;
  }
}
const style = {
  container: {
    minHeight: '5rem',
  },
  nav: {
    minHeight: '5rem',
    color: colors.warmGray,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
};
BackToPage.propTypes = {
  text: PropTypes.any,
  navstyle: PropTypes.object,
};

BackToPage.defaultProps = {
  text: 'Settings',
  link: '/settings',
  navstyle: {},
};
const mapStateToProps = (state) => {
  return {
    nav: state.nav,
    historyBack: state.nav.historyBack,
  };
};
const mapDispatchToProps = {
  setSelectedClinic,
  goBack,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackToPage); //{JSON.stringify(this.props.user)}
